import { LOGO_URL, BRAND_SHORT } from "@/lib/api";

export default function LogoLoader({ label = "Caricamento" }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center app-bg gap-6">
      <div className="logo-loader relative h-24 w-24 rounded-2xl bg-black flex items-center justify-center overflow-hidden">
        <img src={LOGO_URL} alt={BRAND_SHORT} className="h-24 w-24 object-contain scale-[1.7]" />
        <span className="logo-loader-scan" />
      </div>
      <div className="font-mono-tech text-[11px] uppercase tracking-[0.34em] text-zinc-400 dark:text-zinc-500 animate-pulse">
        {label}
      </div>
    </div>
  );
}
